require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-lavanya-ashok.json") })
        }
      }, "path---insights-lavanya-ashok");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-lavanya-ashok!./.cache/json/insights-lavanya-ashok.json
// module id = 1115
// module chunks = 231608221292675